import { render, staticRenderFns } from "./Dragino22222Measurement.vue?vue&type=template&id=4798ff91&scoped=true&"
import script from "./Dragino22222Measurement.vue?vue&type=script&lang=js&"
export * from "./Dragino22222Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Dragino22222Measurement.vue?vue&type=style&index=0&id=4798ff91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798ff91",
  null
  
)

/* custom blocks */
import block0 from "./Dragino22222Measurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports